export enum DataWarehouseDocumentTypes {
    RFQ,
    PO
}